// Issue #246. `audit` has been a distinct value in the notification vocabulary since
// Session 64, written by 8 live call sites, and until Session 74k9 no consuming surface
// rendered it any differently from a routine event. An over-receipt — a financial
// exception where the company is about to be invoiced for material nobody ordered —
// arrived in the bell with the same rail, the same timestamp and the same domain tag as
// the "Delivery received" notification directly beneath it. Raised by Colby during 74k7
// live testing on seeing exactly that.
//
// This module exists because the three consuming surfaces derive their colours by
// different routes: Topbar.js maps event_type through EVENT_TYPE_DOMAIN, while
// NotificationOverlay.js and NotificationsPage.js read notifications.domain directly.
// Writing the severity test inline in each would give three definitions of "audit" that
// drift apart — the same divergence #12, #13 and #215 each cost a session to collapse.
// One definition here, three importers.
//
// Severity is added alongside the domain, never in place of it. Swapping the domain
// colour for the audit colour would break the domain filter chips visually: an
// inventory-filtered list would show rows carrying no inventory colour at all.

const AUDIT_EVENT_TYPES = ['audit'];

export function isAuditEvent(eventType) {
  return !!eventType && AUDIT_EVENT_TYPES.includes(eventType);
}

// Amber rather than red, and deliberately not one of the five locked domain colours.
// An audit event is an exception that needs a human decision, not a failure — and it must
// not read as Safety (#E24B4A) to someone scanning a mixed list.
export const AUDIT_RAIL = '#BA7517';
export const AUDIT_TINT = '#FFF8EC';
export const AUDIT_PILL_BG = '#FAEEDA';
export const AUDIT_PILL_BORDER = '#EF9F27';
export const AUDIT_PILL_TEXT = '#9A5F00';
export const AUDIT_LABEL = 'Audit';
